import script from "./TaskView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskView.vue?vue&type=script&setup=true&lang=js"

import "./TaskView.vue?vue&type=style&index=0&id=19a754b1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a754b1"]])

export default __exports__